import { render, staticRenderFns } from "./CommonRankName.vue?vue&type=template&id=a7da159e&scoped=true"
import script from "./CommonRankName.vue?vue&type=script&lang=ts"
export * from "./CommonRankName.vue?vue&type=script&lang=ts"
import style0 from "./CommonRankName.vue?vue&type=style&index=0&id=a7da159e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7da159e",
  null
  
)

export default component.exports